module.exports = __webpack_public_path__ + "img/sh.75193812.svg";